module.exports = __webpack_public_path__ + "img/IMG_7326.3790ba62.jpeg";